var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.341,
    height: 20,
    viewBox: "0 0 28.341 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "person_add_FILL0_wght400_GRAD0_opsz48",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "person_add_FILL0_wght400_GRAD0_opsz48-2",
    "data-name": "person_add_FILL0_wght400_GRAD0_opsz48",
    d: "M24.222,21.221V17.034H20.035V15.1h4.187V10.915h1.932V15.1h4.187v1.932H26.155v4.187ZM12.306,18.612a4.633,4.633,0,0,1-4.831-4.831A4.633,4.633,0,0,1,12.306,8.95a4.633,4.633,0,0,1,4.831,4.831,4.633,4.633,0,0,1-4.831,4.831ZM2,28.95V25.923a3.831,3.831,0,0,1,.564-2.045A3.412,3.412,0,0,1,4.19,22.509a24.681,24.681,0,0,1,4.3-1.5,16.918,16.918,0,0,1,3.816-.435,16.709,16.709,0,0,1,3.8.435,24.873,24.873,0,0,1,4.283,1.5,3.732,3.732,0,0,1,1.643,1.385,3.672,3.672,0,0,1,.58,2.029V28.95Zm1.932-1.932H20.68v-1.1a1.834,1.834,0,0,0-.29-.982,1.782,1.782,0,0,0-.773-.692,19.032,19.032,0,0,0-3.865-1.4,16.454,16.454,0,0,0-3.446-.338,16.686,16.686,0,0,0-3.462.338,18.9,18.9,0,0,0-3.881,1.4,1.687,1.687,0,0,0-.757.692,1.913,1.913,0,0,0-.274.982Zm8.374-10.338a2.809,2.809,0,0,0,2.9-2.9,2.809,2.809,0,0,0-2.9-2.9,2.809,2.809,0,0,0-2.9,2.9,2.809,2.809,0,0,0,2.9,2.9ZM12.306,13.781ZM12.306,27.018Z",
    transform: "translate(-2 -8.95)",
    fill: "#707070"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUserIcon);
export default __webpack_public_path__ + "static/media/addUserIcon.dd9fb5414c9879836e310e3c96177aea.svg";
export { ForwardRef as ReactComponent };